<template>
  <q-card-section class="card-header bg-dark text-white q-py-sm q-px-md row items-center">
    <slot name="label">
      <div v-if="label" class="card-header__label zubie-font">{{ label }}</div>
    </slot>
    <slot />
  </q-card-section>
</template>

<script>
export default {
  name: 'CardHeader',
  props: {
    label: String,
  },
};
</script>

<style lang="scss">
.card-header {
  min-height: 45px;
}

.card-header__label {
  font-size: 1.1rem;
  line-height: 1.3;
}
</style>
